@if (isBillingAddress) {
	<div>
		<div class="client-property-label">
			<span>{{ 'address-details.company-billing' | translate }}</span>
			<change-label [visible]="isCompanyNameChanged()" [changeSet]="changeSet"></change-label>
		</div>
		<div class="client-property">
			{{ companyName }}
		</div>
	</div>
}

<div class="client-property-label">
	<span>{{ 'address-details.address' | translate }}</span>
	<change-label [visible]="isAddressChanged()" [changeSet]="changeSet"></change-label>
</div>
<div id="address" class="client-property">
	{{ address }}
</div>

@if (showTaxId() | async) {
	<div class="client-property-label">
		<span>{{ 'company-address.taxId' | translate }}</span>
		<change-label [visible]="isTaxIdChanged()" [changeSet]="changeSet"></change-label>
	</div>
	<div class="client-property">
		{{ order.company.additionalParams['taxId'] }}
	</div>
}

@if (showKvkNr() | async) {
	<div class="client-property-label">
		<span>{{ 'company-address.kvkNr' | translate }}</span>
		<change-label [visible]="isKvkNrChanged()" [changeSet]="changeSet"></change-label>
	</div>
	<div class="client-property">
		{{ order.company.additionalParams['kvkNr'] }}
	</div>
}

@if (showMultiSiteQuestion) {
	<div class="form-row radio-row">
		<div class="radio-column">
			<nb-radio id="multiSite" [name]="'multiSite' + RANDOM_NUMBER" [checked]="true" status="primary">
				{{ false | booleanDisplay }}
			</nb-radio>
		</div>
		<div class="radio-description-column">
			{{ 'company-has-certificate.multi-site-question' | translate }}
		</div>
	</div>
}
